import { countryMapping } from 'constants/countries'
import { isEmpty, isNil } from 'lodash'
import { CountryMapType } from 'pages/mfa/types'
import { useEffect, useState } from 'react'
import restClient from 'restClient'

const API_URL = window.API_ROOT + '/api'
const PRIORITY_COUNTRIES = ['NZ', 'AU', 'US', 'GB'] // OS main countries

const fetchCountriesWithExpoStands = async (): Promise<any> => {
  let url = `partners/country_expo_stands/`
  const restClientInstance = restClient(API_URL)
  return restClientInstance('CUSTOM_GET', 'custom', {
    url: url,
  })
}

export const useCountriesWithStands = () => {
  const [countriesWithExpoStands, setCountriesWithExpoStands] = useState<CountryMapType[] | null>(null)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchCountriesWithExpoStands()
        if (isNil(result?.data) || isEmpty(result.data)) {
          setCountriesWithExpoStands([])
          return
        }

        const priorityCountries = result.data.filter((countryISO2) => PRIORITY_COUNTRIES.includes(countryISO2))
        const countries = result.data.filter((countryISO2) => !PRIORITY_COUNTRIES.includes(countryISO2))
        // make the priority country on top of the selection
        const allCountries = [...priorityCountries, ...countries].map((isoCode) => countryMapping[isoCode])
        setCountriesWithExpoStands([...allCountries])
      } catch (error) {
        console.error('Error fetching countries with expo stands', error)
        setCountriesWithExpoStands([])
      }
    }
    fetchData()
  }, [])
  return countriesWithExpoStands
}
